import { render, staticRenderFns } from "./supplierpermonth.vue?vue&type=template&id=52ae3537&"
import script from "./supplierpermonth.vue?vue&type=script&lang=js&"
export * from "./supplierpermonth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports